export default "__VITE_ASSET__xcuhuikj__"